import React from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip, WithTooltip } from "@abb/abb-common-ux-react";
import { RouteComponentProps } from "react-router";
import { v4 as uuidv4 } from "uuid";

import Summary from "../shared/Summary";

import * as CONSTANTS from "../../utilities/Constants";
import SampleViewData, { defaultSampleData, ISampleViewData } from "../../models/sample/SampleViewData";

import "./sample.sass";
import { Translation } from "react-i18next";
import "../../utilities/Extensions";
import NameHeader from "../shared/NameHeader";
import { withRouter } from "react-router-dom";
import AbbTableComponent from '../shared/AbbTableComponent';
import measurementActions from "../../flux/actions/MeasurementActions";
import MeasurementRejectStore from '../../flux/stores/measurement/MeasurementRejectStore';
import { CHANGE_EVENT, KEYED_IN } from '../../utilities/Constants';
import MeasurementApproveStore from '../../flux/stores/measurement/MeasurementApproveStore';
import triggerNotifications from "../../utilities/TriggerNotifications";
import History from "../../utilities/History";
import SampleOverviewStore from "../../flux/stores/sample/OverviewStore";
import { ISampleProperties, ISampleOverviewData, defaultSampleOverviewData } from '../../models/sample/SampleOverviewData';
import { Status } from '../../models/sample/Status';
import { SampleGradeProductFormData } from "../../models/shared/SampleGradeProductFormData";
import productActions from "../../flux/actions/ProductActions";
import gradeActions from "../../flux/actions/GradeActions";
import gradeFormStore from "../../flux/stores/grade/FormStore";
import productFormStore from "../../flux/stores/product/FormStore";
import sampleActions from '../../flux/actions/SampleActions';
import sampleReportStore from '../../flux/stores/sample/ReportStore';
import IColumnHeaderData from '../../models/shared/ColumnHeaderData';
import { Icon } from '@abb/abb-common-ux-react';
import { ABB_CARET_DOWN, ABB_CARET_UP, ABB_CARET_RIGHT, ABB_GRAPH_VIEW, ABB_TABLE_VIEW } from '../../utilities/IconConstants';
import { IReportBody, IReportBodyData } from '../../models/sample/ReportBodyData';
import { IReportPropertyData, PropertyType } from '../../models/sample/ReportProperties';
import measuredPositionStore from '../../flux/stores/sample/MeasuredPositionsStore';
import calculatedPositionStore from '../../flux/stores/sample/CalculatedPositionStore';
import keyedInPositionStore from "../../flux/stores/sample/KeyedInPositionStore";
import _ from "lodash";
import { ChartTypes, DateUnits, ISeries, ITrendDataLimit, Trend, TrendMarkerTypes } from "@iom/trend";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import settingsActions from "../../flux/actions/SettingsAction";
import { defaultMeasurementSettingData, MeasurementSetting } from "../../models/settings/MeasurementSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";
import moment from "moment";
import utility from "../shared/Utility";
import DateTimeActions from "../../flux/actions/DateTimeActions";
import DateTimeStore from "../../flux/stores/sample/DateTimeStore";
import i18next from "i18next";
type PropsType = RouteComponentProps & {
};

interface ILandingState {
    sampleData: SampleViewData;
    measurementId: string;
    showSummary: boolean;
    sampleOverviewData: ISampleOverviewData;
    thresholdSettings: IThresholdSettings[];
    inputGradeName: string;
    inputProductName: string;
    showMore: boolean;
    showGradePopup: boolean;
    showProductPopup: boolean;
    inputCode: string;
    productNameError: boolean;
    gradeNameError: boolean;
    codeError: boolean;
    reportData: IReportPropertyData[];
    expandedRows: any[];
    expandedRowData: any[]
    buttonDisabled: boolean;
    isRowExpanded: boolean;
    series: any;
    selectedValueSingle: number[];
    chartType: ChartTypes;
    dateUnit: DateUnits;
    dateUnitCount: number;
    start?: Date;
    end?: Date;
    settings: MeasurementSetting;
}

class MeasurementOverviewLanding extends React.Component<PropsType, ILandingState> {
    start = new Date(2019, 0, 1, 0, 0, 0, 0);
    end = new Date(2019, 0, 5, 0, 0, 0, 0);

    private minXValue: number;
    private maxXValue: number;

    private _mount: boolean = false;
    private _sampleData: ISampleViewData = defaultSampleData;
    private _isMeasurementRejected: any;
    private _isMeasurementAproved: any;
    private _sampleOverviewData: ISampleOverviewData;
    private _isValid: boolean = false;
    private _message: string[];
    private _reportData: IReportPropertyData[];
    private _measuredPositionData: any[];
    private _calculatedPositionData: any[];
    private _keyedinPositionData: any[];
    private _settingsData: any;
    private _thresholdSettings: any;
    private _gradeCreatedId: string = "";
    private _dateFormat: any = "";
    private _offset: number = 0;

    constructor(props: PropsType) {
        
        super(props);
        this._mount = true;
        const { sampleData, measurementId } = this.props?.location?.state as any;

        this.minXValue = 0;
        this.maxXValue = 200;

        this.state = {
            sampleData,
            measurementId,
            settings: defaultMeasurementSettingData,
            thresholdSettings: [],
            showSummary: false,
            sampleOverviewData: defaultSampleOverviewData,
            inputGradeName: "",
            inputProductName: "",
            showMore: false,
            showGradePopup: false,
            showProductPopup: false,
            inputCode: "",
            productNameError: false,
            gradeNameError: false,
            codeError: false,
            reportData: [],
            expandedRows: [],
            expandedRowData: [],
            buttonDisabled: true,
            isRowExpanded: false,
            selectedValueSingle: [0],
            chartType: 'Bar',
            dateUnit: 'Day',
            dateUnitCount: 4,
            start: this.start,
            end: this.end,
            series: [
                {
                    name: 'Position',
                    color: '#5ABFAE',
                    id: '1',
                    markerStyle: {
                        type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                    },
                    yAxis: {
                        min: this.minXValue,
                        max: this.maxXValue,
                        decimalPlaces: 2
                    },
                    isShownInChart: true,
                    points: this.generateOrdinalData1(0, 20, 1, 0, 100)  // String
                }
            ]
        };

    }

    // ====================================================================

    onDateRangeChange = (start: string | number | Date, end: string | number | Date, dateUnit: DateUnits, dateUnitCount: number, isOnZoom: boolean) => {
        this.setState({
            dateUnit,
            dateUnitCount,
            start: start as Date,
            end: end as Date
        });
    }


    onDataLimitVisibilityChange = (series: ISeries, limit: ITrendDataLimit, isShown: boolean) => {
        let updatedValue = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                let limits = item.dataLimits.map(((line: ITrendDataLimit) => {
                    if (line.name === limit.name) {
                        return { ...line, shownInChart: isShown };
                    } else {
                        return line;
                    }
                }))
                return { ...item, dataLimits: limits }
            } else {
                return item;
            }
        });

        this.setState({ series: updatedValue });
    }

    onChartTypeChange = (chartType: ChartTypes) => {
        this.setState({
            chartType: chartType
        });
        return chartType;
    }

    onSeriesChartTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, chartType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onSeriesColorChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, color: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    getMarkerStyles = (value: string, item: ISeries) => {
        let marker = item.markerStyle ? { ...item.markerStyle } : {};
        if (value === "Circle") {
            marker.type = "Circle";
            marker.fillColor = "white";
        } else if (value === "Square") {
            marker.type = "Square";
            marker.fillColor = "white";
        } else if (value === "FillCircle") {
            marker.type = "Circle";
            marker.fillColor = "SeriesColor";
        } else if (value === "FillSquare") {
            marker.type = "Square";
            marker.fillColor = "SeriesColor";
        } else {
            marker.type = "None";
        }
        return marker;
    }

    onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, markerStyle: { ...series.markerStyle, type: value } } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onSeriesFillTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, fillType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onInvalidPointTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, invalidPointLineType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }


    generateOrdinalData(fromDate: number, toDate: number, interval = 1, min: number, max: number, isNumber = false) {
        const data = [];
        let i = 0;
        while (fromDate < toDate) {
            const obj = {
                xValue: isNumber ? fromDate : 'Sample' + fromDate,
                value: parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
                status: ['Valid', 'Invalid', 'Good'][i % 3],
                customValue: ['Reel', 'Machine', 'Paper'][i % 3]
            };
            data.push(obj);
            fromDate = fromDate + interval;
            i++;
        }
        return data;
    }

    generateOrdinalData1(fromDate: number, toDate: number, interval = 1, min: number, max: number, isNumber = false) {

        const data = [
            {
                xValue: "sample1",
                value: 50
            }
        ];
        return data;
    }

    generateOrdinalData2(rowData: any[], item: any) {
        const trendData: any[] = [];
        rowData.sort(utility.sortAlphaNum).map((row: any) => {
            trendData.push({
                xValue: row.positionName,
                value: row.positionMean != null ? row.positionMean : 0
            });
        })
        if (trendData.length != 0) {
           
                trendData.push({ xValue: "", value: null })
        }
        const yValue: number[] = [item.alarmLow1, item.alarmLow2, item.alarmHigh1, item.alarmHigh2, item.rejectLow, item.rejectHigh];
        trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
            yValue.push(item.value)
        })

        let minYValue: any = 0;
        let maxYValue: any = 0;

        if (Math.sign(_.min(yValue)) === -1) {
            minYValue = _.min(yValue) + (_.min(yValue) / 100 * 5);
            maxYValue = _.max(yValue) - (_.max(yValue) / 100 * 5);
        } else {
            // ITC Changes
            minYValue = _.min(yValue) - (_.min(yValue) / 100 * 5);
            // const minYValue: any = 0;
            maxYValue = _.max(yValue) + (_.max(yValue) / 100 * 5);
        }


        const series = [
            {
                name: 'Position',
                color: '#5ABFAE',
                id: '1',
                markerStyle: {
                    type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                },
                yAxis: {
                    min: minYValue,
                    max: maxYValue,
                    decimalPlaces: item?.decimals
                },
                dataLimits: [
                    {
                        name: 'Alarm Low Limit-1',
                        shownInChart: true,
                        showInToolTip: false,
                        value: item?.alarmLow1,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-1',
                        shownInChart: true,
                        value: item?.alarmHigh1,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm High 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm Low Limit-2',
                        shownInChart: true,
                        value: item?.alarmLow2,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-2',
                        shownInChart: true,
                        value: item?.alarmHigh2,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm High 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Reject Low',
                        shownInChart: true,
                        value: item?.rejectLow,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Reject Low" || x.name === "Reject Limit").colorCode }
                    },
                    {
                        name: 'Reject High',
                        shownInChart: true,
                        value: item?.rejectHigh,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Reject High" || x.name === "Reject Limit").colorCode }
                    }
                ],
                isShownInChart: true,
                points: trendData
            }
        ];
        return series;
    }

    generateOrdinalData3(rowData: any, item: any) {
        const trendData: any[] = [];
        rowData.positionValues.map((row: any) => {
            if(row.count == 0 ){
                trendData.push({
                    xValue: "Calculated",
                    value: row.value != null ? row.value : 0
                });
            } else {
                trendData.push({
                    xValue: row.count?.toString(),
                    value: row.value != null ? row.value : 0
                });
            }
           
        })

        if (trendData.length != 0) {
           
                trendData.push({ xValue: "", value: null })
        }

        const yValue: number[] = [item.alarmLow1, item.alarmLow2, item.alarmHigh1, item.alarmHigh2, item.rejectLow, item.rejectHigh];

        rowData.positionValues.sort(utility.sortAlphaNum).forEach((item: any) => {
            yValue.push(item.value)
        })
        let minYValue: any = 0;
        let maxYValue: any = 0;

        if (Math.sign(_.min(yValue)) === -1) {
            minYValue = _.min(yValue) + (_.min(yValue) / 100 * 5);
            maxYValue = _.max(yValue) - (_.max(yValue) / 100 * 5);
        } else {
            // ITC Changes
            minYValue = _.min(yValue) - (_.min(yValue) / 100 * 5);
            // const minYValue: any = 0;
            maxYValue = _.max(yValue) + (_.max(yValue) / 100 * 5);
        }

        const series = [
            {
                name: 'Position',
                color: '#5ABFAE',
                id: '1',
                markerStyle: {
                    type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                },
                yAxis: {
                    min: minYValue,
                    max: maxYValue,
                    decimalPlaces: item?.decimals
                },
                dataLimits: [
                    {
                        name: 'Alarm Low Limit-1',
                        shownInChart: true,
                        value: item?.alarmLow1,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-1',
                        shownInChart: true,
                        value: item?.alarmHigh1,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm High 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm Low Limit-2',
                        shownInChart: true,
                        value: item?.alarmLow2,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-2',
                        shownInChart: true,
                        value: item?.alarmHigh2,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Alarm High 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Reject Low',
                        shownInChart: true,
                        value: item?.rejectLow,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Reject Low" || x.name === "Reject Limit").colorCode }
                    },
                    {
                        name: 'Reject High',
                        shownInChart: true,
                        value: item?.rejectHigh,
                        className: "custom-line-graph",
                        style: { stroke: this.state.thresholdSettings.find(x => x.name === "Reject High" || x.name === "Reject Limit").colorCode }
                    }
                ],
                isShownInChart: true,
                points: trendData
            }
        ];
        return series;
    }

    generateData(fromDate: Date, toDate: Date, interval = 180000, min: number, max: number) {
        const data = [];
        let i = 0;
        while (fromDate.getTime() < toDate.getTime()) {
            const obj = {
                xValue: new Date(fromDate),
                value: parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
                status: ['Valid', 'Invalid', 'Good'][i % 3],
                customValue: ['Reel', 'Machine', 'Paper'][i % 3]
            };
            data.push(obj);
            fromDate = new Date(fromDate.getTime() + interval);
            i++;
        }
        return data;
    }

    // ====================================================================

    componentWillUnmount() {
        this._mount = false;
    }

    private getGeneralSettings = () => {
        settingsActions.getGeneral().then(() => {
            this.setState({
                settings: this._settingsData,
                chartType: this._settingsData.selectedGraphType.name
            })
        }).catch((e: any) => {
            triggerNotifications.error(e);
        })
    }

    componentDidMount() {
        this._mount = true;

        DateTimeActions.getAll().then(() => { });

        DateTimeStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            const dateObject = state.dateTimeFormatList;
            localStorage.setItem('dateObject', JSON.stringify(dateObject));
            dateObject.dateFormat = dateObject.dateFormat.toUpperCase();
            if (dateObject.timeFormat.includes("tt")) {
                dateObject.timeFormat = "hh:mm A"
            }
            this._dateFormat = `${dateObject.dateFormat} ${dateObject.timeFormat}`;
            this._offset = dateObject.timeOffset;
        });

        MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._isMeasurementRejected = state.isMeasurementRejected
            }
        });

        MeasurementApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._isMeasurementAproved = state.isMeasurementApproved
            }
        });

        SampleOverviewStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._sampleOverviewData = state.data
            }
        })

        gradeFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
            if (this._mount) {
                this._gradeCreatedId = state.gradeId;
                this._message = state.message;
            }
        })

        productFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
            if (this._mount) {
                this._message = state.message;
            }
        });

        sampleReportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._reportData = state.reportData.properties
            }
        });

        measuredPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._measuredPositionData = state.data.data.propertyPositionValues
            }
        });

        calculatedPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._calculatedPositionData = state.data.data.calculatedPositionValue
            }
        });
        keyedInPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._keyedinPositionData = state.data.data.propertyPositionValues
            }
        });
        measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._settingsData = state.data
            }
        });

        thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
            if (this._mount) {
                this._thresholdSettings = state.data
            }
        });



        this.getGeneralSettings();
        this.getThresholdValues();
        this.measurementOverview();
    }

    private getThresholdValues = () => {
        settingsActions.getThresholdReport().then(() => {
            this.setState({
                thresholdSettings: this._thresholdSettings
            })
        }).catch((e) => {
            triggerNotifications.error(e);
        })
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.location.key !== this.props.location.key) {
            const { sampleData, measurementId } = this.props?.location?.state as any;
            if (sampleData !== undefined) {
                if (this.state.sampleData.id !== sampleData.id) {
                    this.setState({
                        expandedRowData: [],
                        expandedRows: [],
                        sampleData
                    }, () => this.measurementOverview())
                }
            }
        }
    }

    public onShowSummary = () => {
        this.setState({
            showSummary: !this.state.showSummary
        })
    }

    private measurementOverview = () => {
        measurementActions.getMeasurementOverviewDetail(this.state.sampleData.id).then(() => {
            this.setState({
                sampleOverviewData: this._sampleOverviewData,
                measurementId: this._sampleOverviewData.measurementId
            }, () => {
                sampleActions.getReport(this.state.sampleData.id, this.state.measurementId, this.state.sampleData?.product?.id)
                    .then(() => {
                        this.setState({ reportData: this._reportData })
                    }).catch((error) => triggerNotifications.errors(error.message, error.data).then())
            })
        }).catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
        });
    }


    private measurementApprove = () => {
        measurementActions.approveSampleMeasurement(this.state.sampleData.id,
            this.state.measurementId, uuidv4()).then(
                () => {
                    if (this._isMeasurementAproved) {
                        triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
                        setTimeout(() => {
                            History.push({
                                pathname: CONSTANTS.SAMPLE_INDEX_URL
                            })
                        }, CONSTANTS.NOTIFICATION_TIMEOUT);
                    }
                }
            ).catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    private measurementReject = () => {
        measurementActions.rejectSampleMeasurement(this.state.sampleData.id,
            this.state.measurementId, uuidv4()).then(
                () => {
                    if (this._isMeasurementRejected) {
                        triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
                        setTimeout(() => {
                            History.push({
                                pathname: CONSTANTS.SAMPLE_INDEX_URL
                            })
                        }, CONSTANTS.NOTIFICATION_TIMEOUT);
                    }
                }
            ).catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
            })
    }

    public setGradeName = (value: string) => {
        const val = value.length > 1 ? value : value.replace(/\s/g, "")
        if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
            this.setState({ gradeNameError: false, inputGradeName: val }, this.validate)
        } else {
            this.setState({ gradeNameError: true, inputGradeName: val }, this.validate)
        }
    }

    public setProductName = (value: string) => {
        const val = value.length > 1 ? value : value.replace(/\s/g, "")
        if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
            this.setState({ productNameError: false, inputProductName: val }, this.validate)
        } else {
            this.setState({ productNameError: true, inputProductName: val }, this.validate)
        }

    }

    public setCode = (value: string) => {
        const val = value.length > 1 ? value : value.replace(/\s/g, "")
        if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
            this.setState({ codeError: false, inputCode: val }, this.validate)
        } else {
            this.setState({ codeError: true, inputCode: val }, this.validate)
        }
    }


    public onGradeActivate = () => {
        this.setState({
            showGradePopup: true,
            showProductPopup: false,
            showMore: false
        });
    }

    public onProductActivate = () => {
        this.setState({
            showProductPopup: true,
            showGradePopup: false,
            showMore: false
        });
    }
    public onMoreClick = () => {
        this.setState({
            showMore: !this.state.showMore
        })
    }


    public onCloseGrade = () => {
        this.setState({
            showGradePopup: false,
            gradeNameError: false,
            productNameError: false,
            codeError: false,
            inputGradeName: "",
            inputCode: ""
        });
    }
    public onCloseProduct = () => {
        this.setState({
            showProductPopup: false,
            gradeNameError: false,
            productNameError: false,
            codeError: false,
            inputProductName: "",
            inputCode: ""
        });
    }

    public onCreateProduct = (e: any, val: boolean) => {
        this.setState({
            showProductPopup: false,
        });
        const sampleId = this.state.sampleData.id;
        const productName = this.state.inputProductName;
        const codeId = this.state.inputCode;
        if (this._isValid) {
            const productBody = new SampleGradeProductFormData(uuidv4(), sampleId, productName, codeId);
            productActions.createProductSample(productBody, "00000000-0000-0000-0000-000000000000").then(() => {
                triggerNotifications.success(this._message).then();
                this.setState({
                    inputProductName: "",
                    inputCode: "",
                    gradeNameError: false,
                    productNameError: false,
                    codeError: false,
                    buttonDisabled: true
                })
            }).catch((error) => {
                this.setState({
                    inputProductName: "",
                    inputCode: "",
                    gradeNameError: false,
                    productNameError: false,
                    codeError: false,
                    buttonDisabled: true
                }, () => triggerNotifications.errors(error.message, error.data).then());
            })
        } else {
            this.setState({
                inputProductName: "",
                inputCode: "",
                gradeNameError: false,
                productNameError: false,
                codeError: false,
            }, () => triggerNotifications.error(CONSTANTS.NAME_OR_CODEID_REQUIRED))

        }
    }

    public onCreateGrade = (e: any, val: boolean) => {
        this.setState({
            showGradePopup: false,
        });
        const sampleId = this.state.sampleData.id;
        const gradeName = this.state.inputGradeName;
        const codeId = this.state.inputCode;
        if (this._isValid) {
            const gradeBody = new SampleGradeProductFormData(uuidv4(), sampleId, gradeName, codeId);
            gradeActions.createGradeSample(gradeBody).then(() => {
                const productBody = new SampleGradeProductFormData(uuidv4(), sampleId, gradeName, codeId);
                productActions.createProductSample(productBody, this._gradeCreatedId).then(() => {
                    triggerNotifications.success([i18next.t('Grade and Product created')]).then();
                    this.setState({
                        inputGradeName: "",
                        inputCode: "",
                        gradeNameError: false,
                        productNameError: false,
                        codeError: false,
                        buttonDisabled: true
                    })
                })
            }).catch((error) => {
                this.setState({
                    inputGradeName: "",
                    inputCode: "",
                    gradeNameError: false,
                    productNameError: false,
                    codeError: false,
                    buttonDisabled: true
                }, () => triggerNotifications.errors(error.message, error.data).then());
            })
        } else {
            this.setState({
                inputGradeName: "",
                inputProductName: "",
                inputCode: "",
                gradeNameError: false,
                productNameError: false,
                codeError: false,
            }, () => triggerNotifications.error(CONSTANTS.NAME_OR_CODEID_REQUIRED))
        }
    }

    validate(): void {
        if ((!this.state.codeError && this.state.inputCode.trim() && this.state.inputCode !== "") &&
            (!this.state.gradeNameError && this.state.inputGradeName.trim() && this.state.inputGradeName !== "" ||
                !this.state.productNameError && this.state.inputProductName.trim() && this.state.inputProductName !== "")) {
            this._isValid = true;
            this.setState({
                buttonDisabled: false
            })
        } else {
            this._isValid = false;
            this.setState({
                buttonDisabled: true
            })
        }
    }

    handleRowClick(rowId: IReportPropertyData) {
        const newExpandedRowId = rowId.id + "-" + rowId.name;
        if (this.state.expandedRows.includes(newExpandedRowId)) {
            this.setState({
                expandedRows: [],
                expandedRowData: []
            })
        } else {
            this.setState({
                expandedRows: []
            }, () => {

                const currentExpandedRows: any[] = this.state.expandedRows;
                const isRowCurrentlyExpanded = currentExpandedRows.includes(newExpandedRowId);

                const newExpandedRows = isRowCurrentlyExpanded ?
                    currentExpandedRows.filter(id => id !== rowId) :
                    currentExpandedRows.concat(newExpandedRowId);

                this.setState({ expandedRows: newExpandedRows, expandedRowData: [] }, () => {
                    if (rowId.propertyType === PropertyType.MEASURED) {
                        this.measuredPosition(rowId.instrumentId, rowId.id, rowId.directionId, rowId.name)
                    } else if (rowId.propertyType === PropertyType.KEYEDIN) {
                        this.keyedInPosition(rowId.id, rowId.directionId, rowId.name)
                    } else {
                        this.calculatedPosition(rowId.id, rowId.name)
                    }
                })
            })
        }
    }

    changeSelectedHandler = (item: any, series: any) => {
        const thresholdSettings: any[] = []
        const seriesData = JSON.parse(JSON.stringify(series));
        this.state.thresholdSettings.map((element, index) => {
            if (index === item) {
                element.isActive = !element.isActive
                seriesData[0]?.dataLimits?.forEach((el: any) => {
                    if (item == 0) {
                        if (el.name === "Alarm Low Limit-1" || el.name === "Alarm High Limit-1") {
                            if (element.isActive) {
                                el.shownInChart = true;
                            } else {
                                el.shownInChart = false;
                            }
                        }
                    }
                    if (item == 1) {
                        if (el.name === "Alarm Low Limit-2" || el.name === "Alarm High Limit-2") {
                            if (element.isActive) {
                                el.shownInChart = true;
                            } else {
                                el.shownInChart = false;
                            }
                        }
                    }
                    if (item == 4) {
                        if (el.name === "Reject Low" || el.name === "Reject High") {
                            if (element.isActive) {
                                el.shownInChart = true;
                            } else {
                                el.shownInChart = false;
                            }
                        }
                    }
                })
                thresholdSettings.push(element)
            } else {
                thresholdSettings.push(element)
            }
        })

        this.setState({
            thresholdSettings: thresholdSettings,
            series: seriesData
        }, () => {
            console.log(this.state?.series);
        })
    }

    renderItem(data: any) {
        const clickCallback = () => this.handleRowClick(data);
        const itemRows = [
            <tr key={"row-data-" + data.id}
                onClick={clickCallback}
                style={this.state.expandedRows.includes(data.id + "-" + data.name) ? { background: "#DBDBDB" } : {}}
                className="cursor-pointer">
                <td className="normal-row">
                    <Icon
                        name={this.state.expandedRows.includes(data.id + "-" + data.name) ? ABB_CARET_DOWN : ABB_CARET_RIGHT}
                        sizeClass="medium"
                        color="black"
                    />
                </td>
                <td className="normal-row">
                    <WithTooltip>
                        <span className="text-ellipsis width-8rem">{data.name.replace('--', '')}​​​​​</span>
                        <Tooltip className="nav-tooltip">
                            <p>{data.name.replace('--', '')}​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>
                <td className="normal-row">{data.unit}</td>
                <td className="normal-row">
                    <WithTooltip>
                        <span className="text-ellipsis width-5rem">{(data != null && data.mean != null && !isNaN(data.mean)) ? data.mean.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</span>
                        <Tooltip className="px-2 nav-tooltip">
                            <p>{(data != null && data.mean != null && !isNaN(data.mean)) ? data.mean.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>
                <td className="normal-row">
                    <WithTooltip>
                        <span className="text-ellipsis width-5rem">{(data != null && data.standardDeviation != null && !isNaN(data.standardDeviation)) ? data.standardDeviation.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</span>
                        <Tooltip className="px-2 nav-tooltip">
                            <p>{(data != null && data.standardDeviation != null && !isNaN(data.standardDeviation)) ? data.standardDeviation.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>
                <td className="normal-row">
                    <WithTooltip>
                        <span className="text-ellipsis width-5rem">{data != null && data.min != null && !isNaN(data.min) ? Number(data.min).toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</span>
                        <Tooltip className="px-2 nav-tooltip">
                            <p>{data != null && data.min != null && !isNaN(data.min) ? Number(data.min).toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>
                <td className="normal-row">
                    <WithTooltip>
                        <span className="text-ellipsis width-5rem">{data != null && data.max != null && !isNaN(data.max) ? Number(data.max).toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</span>
                        <Tooltip className="px-2 nav-tooltip">
                            <p>{data != null && data.max != null && !isNaN(data.max) ? Number(data.max).toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>
                <td className="normal-row">{data.ok}</td>
                <td className="normal-row">{data.alarm1}</td>
                <td className="normal-row">{data.alarm2}</td>
                <td className="normal-row">{data.reject}</td>
            </tr>
        ];
        if (this.state.expandedRows.includes(data.id + "-" + data.name)) {
            const indexId = data.id + "-" + data.name;
            let max = -Infinity;
            let iterableData: any[] = [];
            let countData: any[] = [];
            this.state.expandedRowData.forEach(function (a, i) {
                if (a.id === indexId) {
                    countData.push(a)
                    iterableData.push(a.positionValues)
                }
            });
            const maxIterable = iterableData.map(a => a.length);
            maxIterable.indexOf(Math.max(...maxIterable));
            max = Math.max(...maxIterable);
            const b = _.maxBy(countData, 'positionCounts.totalCounts');
            itemRows.push(
                <div
                    key={Math.random()}
                    className="p-4"
                    style={{
                        background: "#DBDBDB",
                        width: "78.9vw",
                        marginTop: "-4px"
                    }}>

                    <React.Fragment>
                        <div className="fr" style={{ marginRight: "2rem", cursor: "pointer" }}>
                            {this.state?.thresholdSettings?.map((th: any, i: number) => {
                                return th.key === 'RJLT' || th.key === 'ALLT2' || th.key === 'ALLT1' ? <div className={th?.isActive ? 'fl threshold fullopacity' : 'fl threshold halfopacity'} key={i} onClick={(e) => this.changeSelectedHandler(i, this.state.series)}>
                                    <div className="fl threshold-box" style={{ background: th?.colorCode }} />
                                    <span className="fl threshold-text">{i18next.t(th?.name)} </span></div> : ""
                            })}
                        </div>
                        <div className="clearfix" />
                    </React.Fragment >

                    <div className="abb-wrapper">
                        <div className="abb-scroller">
                            <table className="abb-count-table w-100">
                                {
                                    (this.state.selectedValueSingle[0] === 0) ?
                                        <React.Fragment>
                                            <thead>
                                                <tr>
                                                    <th className="row-data">{i18next.t("Position")}</th>
                                                    <th className="row-data">{i18next.t("Counts")}</th>
                                                    <th className="row-data">{i18next.t("Pos. Avg")}</th>
                                                    {this.iterablesHeader(b)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.expandedRowData.map((dt, index) => {
                                                    if (dt.id === indexId) {
                                                        return <tr key={"row-expanded-" + dt.id}>
                                                            <td className="normal-row">{dt !== undefined && dt.positionName}</td>
                                                            <td className="normal-row">{dt !== undefined && dt.propertyType === undefined && dt.positionCounts.completedCounts + " /" + dt.positionCounts.totalCounts}</td>
                                                            <td className="normal-row">
                                                                <WithTooltip>
                                                                    <div className="text-ellipsis width-5rem">{(dt !== undefined && dt.positionMean != null && !isNaN(dt.positionMean)) ? dt.positionMean.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</div>
                                                                    <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                                                                        <p>{(dt !== undefined && dt.positionMean != null && !isNaN(dt.positionMean)) ? dt.positionMean.toFixed(data.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC}​​​​​</p>
                                                                    </Tooltip>
                                                                </WithTooltip>
                                                            </td>
                                                            {this.iterables(dt, index, maxIterable, max, b, data)}
                                                        </tr>
                                                    }
                                                })}
                                            </tbody>
                                        </React.Fragment>
                                        :
                                        <tbody>
                                            <tr >
                                                <td colSpan={7}>
                                                    {this.state.series[0].points?.length > 0 ? <Trend
                                                        chartType={this.state.settings?.selectedGraphType?.name}
                                                        invalidPointLineType='None'
                                                        invalidStatuses={['Invalid']}
                                                        dateUnit={this.state.dateUnit}
                                                        dateUnitCount={this.state.dateUnitCount}
                                                        gridLineColor='grey'
                                                        gridLineWidth={0.5}
                                                        showVerticalGridLines={false}
                                                        showHorizontalGridLines={true}
                                                        series={this.state.series}
                                                        xAxis={{ type: 'Ordinal', tickAngle: 45, height: 60 }}
                                                        onChartTypeChange={this.onChartTypeChange}
                                                        onDataLimitVisibilityChange={this.onDataLimitVisibilityChange}
                                                        onDateRangeChange={this.onDateRangeChange}
                                                        onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                                                        onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                                                        onSeriesColorChange={this.onSeriesColorChange}
                                                        onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                                                        onSeriesMarkerChange={this.onSeriesMarkerChange}
                                                        trendChartHeight={300}
                                                        showChartType={false}
                                                        showDateTimePicker={false}
                                                        showOuterBorder={false}
                                                        showTableData={false}
                                                        yAxisTicksCount={5}
                                                        yAxisWidth={75}
                                                        tooltipPosition="Middle"
                                                    />
                                                        : <div>
                                                            <NoTrendToDisplay></NoTrendToDisplay>
                                                        </div>}
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>
                    </div>
                </div >
            );
        }
        return itemRows;
    }

    private iterablesHeader(b: any) {
        let arr: any[] = [];
        if (b !== undefined) {
            for (let i = 0; i < b.positionCounts.totalCounts; i++) {
                arr.push(<th className="row-data" key={i}>
                    {i + 1}
                </th>)
            }
        }
        return arr
    }

    private iterables(data: any, index: number, maxIterable: any[], max: number, b: any, mainData: any) {

        let count = b && b.positionCounts ? b?.positionCounts?.totalCounts : max;
        let arr: any[] = [];
        if (max !== undefined) {
            for (let i = 0; i < count; i++) {
                const val = data.positionValues[i];
                let value;
                if (mainData.propertyType === PropertyType.KEYEDIN) {
                    const dd = data.positionValues.find((x: any) => x.count === i + 2)
                    value = dd !== undefined && dd.value != null && !isNaN(dd.value) ? dd.value.toFixed(mainData.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC;
                } else {
                    const val = data.positionValues[i];
                    value = val !== undefined && val.value != null && !isNaN(val.value) ? val.value.toFixed(mainData.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC;
                }

                let color = "#262626"
                if (val !== undefined) {
                    if (val.valueRangeStatus === "Alarm Limit1") {
                        color = this.state.thresholdSettings.find(x => x.name === "Alarm Limit1").colorCode;
                    } else if (val.valueRangeStatus === "Alarm Limit2") {
                        color = this.state.thresholdSettings.find(x => x.name === "Alarm Limit2").colorCode;
                    } else if (val.valueRangeStatus === "Reject Limit") {
                        color = this.state.thresholdSettings.find(x => x.name === "Reject Limit").colorCode;
                    }

                }
                arr.push(<td className="normal-row" key={index} style={{ color }}>
                    <WithTooltip>
                        <div className="text-ellipsis width-5rem">{value}​​​​​</div>
                        <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{value}​​​​​</p>
                        </Tooltip>
                    </WithTooltip>
                </td>)
            }
        }
        return arr
    }

    private measuredPosition = (instrumentId: string, propertyId: string, directionId: string, propertyName: string) => {
        sampleActions.getMeasuredPropertyPosition(this.state.measurementId,
            instrumentId, propertyId, directionId)
            .then(() => {
                const indexId = propertyId + "-" + propertyName;
                let rowData: any[] = [];
                this._measuredPositionData.map((data, index) => {
                    const pushData = { ...data, id: indexId };
                    rowData.push(pushData)
                })

                let item = this.state.reportData.find((items) => { return items.name === propertyName });

                const expandedRowData = _.uniqBy(rowData, function (e) {
                    return e.id && e.position
                });
                const trendData = this.generateOrdinalData2(rowData, item);
                this.setState({ expandedRowData: [...this.state.expandedRowData, ...rowData], series: trendData })
            })
            .catch((error) => triggerNotifications.errors(error.message, error.data).then())
    }
    private keyedInPosition = (propertyId: string, directionId: string, propertyName: string) => {
        sampleActions.getKeyedInPropertyPosition(this.state.measurementId,
            propertyId, directionId)
            .then(() => {
                const indexId = propertyId + "-" + propertyName;
                let rowData: any[] = [];
                this._keyedinPositionData.map((data, index) => {
                    const pushData = { ...data, id: indexId };
                    rowData.push(pushData)
                })
                let item = this.state.reportData.find((items) => { return items.name === propertyName });
                const expandedRowData = _.uniqBy(rowData, function (e) {
                    return e.id;
                });
                const trendData = this.generateOrdinalData2(rowData, item);
                this.setState({ expandedRowData: [...this.state.expandedRowData, ...rowData], series: trendData })

            })
            .catch((error) => triggerNotifications.errors(error.message, error.data).then())
    }


    private calculatedPosition = (propertyId: string, propertyName: string) => {
        sampleActions.getCalculatedPropertyPosition(this.state.measurementId, propertyId)
            .then(() => {
                const indexId = propertyId + "-" + propertyName;
                if (this._calculatedPositionData !== null) {
                    const dt = { ...this._calculatedPositionData, id: indexId, propertyType: PropertyType.CALCULATED }
                    let item = this.state.reportData.find((items) => { return items.name === propertyName });
                    const trendData = this.generateOrdinalData3(dt, item);
                    this.setState({ expandedRowData: [dt], series: trendData })
                }

            })
            .catch((error) => triggerNotifications.errors(error.message, error.data).then())
    }

    public setSelectedValueSingle = (v: any) => {
        this.setState({ selectedValueSingle: v })
    }

    public render() {
        return (
            <Translation>
                {t => (
                    <React.Fragment>
                        <div className="page-layout" >

                            {this.state.sampleData.status.name === Status.APPROVED
                                || this.state.sampleData.status.name === Status.REJECTED ? <NameHeader
                                data={this.state.sampleData.name}
                                measurementState={this.state.sampleData.status.name}
                                isMeasure={true}
                            />
                                :
                                <NameHeader
                                authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE}
                                    data={this.state.sampleData.name}
                                    measurementReject={this.measurementReject}
                                    measurementApprove={this.measurementApprove}
                                    isComplete={true}
                                    gradeNameError={this.state.gradeNameError}
                                    productNameError={this.state.productNameError}
                                    codeError={this.state.codeError}
                                    setGradeName={(val: string) => this.setGradeName(val)}
                                    gradeName={this.state.inputGradeName}
                                    isShowGradePopup={this.state.showGradePopup}
                                    setProductName={(val: string) => this.setProductName(val)}
                                    productName={this.state.inputProductName} isShowProductPopup={this.state.showProductPopup}
                                    onCreateGrade={this.onCreateGrade} onCreateProduct={this.onCreateProduct}
                                    onGradeActivate={this.onGradeActivate} onProductActivate={this.onProductActivate}
                                    inputCode={this.state.inputCode} setCode={(val: string) => this.setCode(val)}
                                    isShowMore={this.state.showMore} onMoreClick={this.onMoreClick}
                                    onCloseProduct={this.onCloseProduct} onCloseGrade={this.onCloseGrade}
                                    isButtonDisabled={this.state.buttonDisabled}
                                />
                            }
                            <div className="summary-layout">
                                <Summary
                                    isToggle={true}
                                    isShow={this.state.showSummary} onToggleShow={this.onShowSummary}>
                                    <div className="page-scroll">
                                        <div className="row mt-1 ml-2">
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.MODULE_SOURCE)}:
                                                </span>
                                                <span className="summary-value ml-2 text-ellipsis width-10rem">
                                                    {this.state.sampleData?.source?.name}
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.MODULE_PRODUCT)}:
                                                </span>
                                                <span className="summary-value ml-2 text-ellipsis width-9rem">
                                                    {this.state.sampleData?.product?.name}
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.MODULE_GRADE)}:
                                                </span>
                                                <span className="summary-value ml-2 text-ellipsis width-9rem">
                                                    {this.state.sampleData?.product?.grade?.name}
                                                </span>
                                            </div>
                                            <div className="col-3">
                                                <span className="summary-label">{t(CONSTANTS.MODULE_TESTPLAN)}:{" "}
                                                </span>
                                                <span className="summary-value ml-2">
                                                    <WithTooltip>
                                                        <span className="text-ellipsis width-9rem">{this.state.sampleData?.testPlan?.name}</span>
                                                        <Tooltip>
                                                            <span>{this.state.sampleData?.testPlan?.name}</span>
                                                        </Tooltip>
                                                    </WithTooltip>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row ml-2">
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.LABEL_SETID)}:
                                                </span>
                                                <span className="summary-value ml-2">
                                                    {this.state.sampleData?.setId}
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.LABEL_ORDERID)}:
                                                </span>
                                                <span className="summary-value ml-2">
                                                    {this.state.sampleData?.orderId}
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.LABEL_DATECREATED)}:</span>
                                                <span className="summary-value ml-2">
                                                    {this.state.sampleData?.formatedDate}
                                                </span>
                                            </div>
                                            <div className="col-md-3">
                                                <span className="summary-label">
                                                    {t(CONSTANTS.LABEL_DATE_MODIFIED)}:
                                                </span>
                                                <span className="summary-value ml-2">
                                                    {this.state.sampleData?.updatedOn}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 ml-2">
                                            <span className="summary-label">
                                                {t(CONSTANTS.LABEL_REMARKS)}:
                                            </span>
                                            <WithTooltip>
                                                <div style={{ display: "inline-block", verticalAlign: "sub" }} className="summary-value ml-2 text-ellipsis width-8rem">
                                                    {this.state.sampleData?.description}
                                                </div>
                                                <Tooltip style={{ width: '200px' }}>
                                                    <p> {this.state.sampleData?.description}</p>
                                                </Tooltip>
                                            </WithTooltip>
                                        </div>
                                    </div>
                                </Summary>
                            </div>

                            <div className="mt-2 summary">
                                <div className="summary-text">
                                    <div className="d-inline-block">{t(CONSTANTS.MODULE_PROPERTY + " " + CONSTANTS.LABEL_SUMMARY)}</div>
                                    <div className="d-inline-block float-right" style={{ cursor: "pointer", marginRight: "20px" }}>
                                        {
                                            this.state.selectedValueSingle[0] == 1 ?
                                                <WithTooltip>
                                                    <Icon name={ABB_TABLE_VIEW} sizeClass="large"
                                                        onClick={() => this.setSelectedValueSingle([0])}
                                                        color="#3366FF"
                                                    />
                                                    <Tooltip className="nav-tooltip">
                                                        <p>{t("Table View")}</p>
                                                    </Tooltip>
                                                </WithTooltip>
                                                :
                                                <WithTooltip>
                                                    <Icon name={ABB_GRAPH_VIEW} sizeClass="large"
                                                        onClick={() => this.setSelectedValueSingle([1])}
                                                        color="#3366FF"
                                                    />
                                                    <Tooltip className="nav-tooltip">
                                                        <p>{t("Graph View")}</p>
                                                    </Tooltip>
                                                </WithTooltip>
                                        }
                                    </div>
                                </div>

                                <div className="header-underline" />
                                <div className="w-100">
                                    <div className="p-4">
                                        <div className="abb-wrapper">
                                            <div className="abb-scroller">
                                                <table className="abb-report-table w-100 report-sum-table">
                                                    <thead>
                                                        <tr>
                                                            <th className="row-data-toggle" />
                                                            <th className="row-data property-col">{t("Property Name")}</th>
                                                            <th className="row-data">{t("Unit")}</th>
                                                            <th className="row-data">{t("Avg")}</th>
                                                            <th className="row-data">{t("Std Dev")}</th>
                                                            <th className="row-data">{t("MIN")}</th>
                                                            <th className="row-data">{t("MAX")}</th>
                                                            <th className="row-data">{t("OK")}</th>
                                                            <th className="row-data">{t("Alarm1")}</th>
                                                            <th className="row-data">{t("Alarm2")}</th>
                                                            <th className="row-data">{t("REJECT")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{this.state.reportData?.map(item => {
                                                        return this.renderItem(item);
                                                    })}</tbody></table>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </React.Fragment>
                )}
            </Translation>
        );
    }

}

export default withRouter(MeasurementOverviewLanding)